import { useState, useContext } from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import { UserContext } from './context.js';
import {UsernameField, PasswordField, Submit} from './Fields.js';
import Typography from '@mui/material/Typography';
import { Link, useNavigate } from "react-router-dom";
import nwsFetch from './customFetch.js';

export default function Login(){
	const navigate = useNavigate();
	const setUser = useContext(UserContext)[1];
	const [username, setUsername] = useState("");
	const [password, setPassword] = useState("");
	const [error, setError] = useState({});
	async function onSubmit(){
		const data = {
			username: username,
			password: password,
		}
		let response = await nwsFetch("/accounts/api/login/", {
			method: "POST",
			body: JSON.stringify(data),
		});
		if(response.ok){
			setUser(await response.json());
			return navigate("/");
		}else{
			setError(await response.json());
		}
	}
	return (
		<Container maxWidth="sm">
			<Box component="form">
				<Typography variant="h3" component="h3">
				  Sign In	
				</Typography>
				<UsernameField setField={setUsername} error={error}/>
				<PasswordField setField={setPassword} error={error}/>
				<Link align="left" to="/reset_password">Reset Password</Link>
				<Submit onSubmit={onSubmit} error={error} name="Sign In"/>
				<Typography sx={{textAlign: "center"}} variant="h6" component="h6">
					Do not have an account? <Link to="/signup" >Sign up</Link>
				</Typography>
			</Box>
		</Container>
	)
}
